import axiosClient from '@/api/axiosClient';
import {
  API_CREATE_SEND_SMS,
  API_GET_SEND_SMS_DETAIL,
  API_GET_SEND_SMS_OVERVIEW,
  API_POST_RESEND_SMS,
} from '@/config/paths/API_PATH';

const getSendSmsOverview = async (params) => {
  const { data } = await axiosClient.get(API_GET_SEND_SMS_OVERVIEW, { params });

  return data;
};

const getSendSmsDetail = async (params) => {
  const { data } = await axiosClient.get(API_GET_SEND_SMS_DETAIL, { params });

  return data;
};

const postCreateSendSms = async (body) => {
  const { data } = await axiosClient.post(API_CREATE_SEND_SMS, body);

  return data;
};

const postResendSms = async (body) => {
  const { data } = await axiosClient.post(API_POST_RESEND_SMS, body);

  return data;
};

export { getSendSmsOverview, getSendSmsDetail, postCreateSendSms, postResendSms };
